// Global Instructions Rule Applied!
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from '../store.ts'
import { resolveReportIdForMenuItem } from '../utils/reportingGridColumns.ts'
import { MENU_ITEM_KEY_INVESTMENTS } from '../globals.ts'

const REPORT_CONFIG_NAME_INVESTMENT_DETAIL = 'Investment Detail'

/** `reporting_config.id` for the standalone, multi-fund Investments screen. */
export function useInvestmentDetailReportId(): string | undefined {
  const menuItems = useSelector((state: RootState) => state.globalConfigs?.menu_items ?? [])
  const reportingConfigs = useSelector((state: RootState) => state.globalConfigs?.reporting_configs ?? [])

  return useMemo(
    () =>
      resolveReportIdForMenuItem(
        reportingConfigs,
        menuItems,
        MENU_ITEM_KEY_INVESTMENTS,
        REPORT_CONFIG_NAME_INVESTMENT_DETAIL
      ),
    [menuItems, reportingConfigs]
  )
}
